exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n.v-input--checkbox.v-input--indeterminate.v-input--is-disabled {\n  opacity: 0.6;\n}", ""]);

